import {
	Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges,
	SimpleChange, ChangeDetectionStrategy, ChangeDetectorRef, OnDestroy, QueryList,
	ViewChild, ViewChildren, ElementRef
} from '@angular/core';
import { UserDto, UserClass, getAccountTypeLabel } from 'UvExplorerServer.Dtos.TS/Auth';
import { Table } from 'primeng/table';
import { Dialog } from 'primeng/dialog';
import { UsersService } from '../../services/users.service';


export class UserSelectorEntry {
	public dataKey: string;
	public username: string;
	public firstName: string;
	public lastName: string;
	public class: string;
	public type: string;
	public active: string;

	public userTag: UserDto;
	public get hasUserTag(): boolean {
		return !!this.userTag;
	}

	constructor() {
		this.dataKey = "";

		this.username = "";
		this.firstName = "";
		this.lastName = "";
		this.class = "";
		this.type = "";
		this.active = "";

		this.userTag = null;
	}
}


@Component({
	selector: 'user-selector',
	templateUrl: './user-selector.component.html',
	styleUrls: ['./user-selector.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserSelectorComponent implements OnInit, OnChanges, OnDestroy {

	@Input()
	public header: string;

	@Input()
	public visible: boolean;

	@Input()
	public minUsers: number;

	@Input()
	public maxUsers: number;

	@Input()
	public except: string[];

	// "full" or "compact"
	@Input()
	public format: string;

	@Output()
	public visibleChange: EventEmitter<boolean>;

	@Output()
	public onOk: EventEmitter<UserDto[]>

	@Output()
	public onCancel: EventEmitter<any>;

	@ViewChild('dialog', { static: true })
	public dialog: Dialog;

	@ViewChild('table', { static: true })
	public table: Table;

	@ViewChildren('filter')
	public filters: QueryList<ElementRef<HTMLInputElement>>;

	public cols: any[];
	public entries: UserSelectorEntry[];
	public filterEntries: any[];

	public selectedUsers: any;

	constructor(private changeDetector: ChangeDetectorRef,
		private usersService: UsersService) {

		this.header = "";
		this.visible = false;
		this.minUsers = 1;
		this.maxUsers = 1;
		this.except = [];
		this.format = "full";
		this.visibleChange = new EventEmitter<boolean>();
		this.onOk = new EventEmitter<UserDto[]>();
		this.onCancel = new EventEmitter<any>();
		this.cols = [];
		this.entries = [];

		this.clearSelectedUsers();
	}

	private rebuildColumns(): void {
		let isFormatFull = (this.format === "full");

		this.cols = [];
		this.cols.push({ field: 'username', header: 'Username', sortable: "custom", sortFunction: (event) => this.doCustomSort(event), filterMatchMode: "contains" });
		this.cols.push({ field: 'firstName', header: 'First Name', sortable: "custom", sortFunction: (event) => this.doCustomSort(event), filterMatchMode: "contains" });
		this.cols.push({ field: 'lastName', header: 'Last Name', sortable: "custom", sortFunction: (event) => this.doCustomSort(event), filterMatchMode: "contains" });
		if (isFormatFull) {
			this.cols.push({ field: 'class', header: 'Class', sortable: "custom", sortFunction: (event) => this.doCustomSort(event), filterMatchMode: "contains" });
		}
		this.cols.push({ field: 'type', header: 'Type', sortable: "custom", sortFunction: (event) => this.doCustomSort(event), filterMatchMode: "contains" });
		this.cols.push({ field: 'active', header: 'Active', sortable: "custom", sortFunction: (event) => this.doCustomSort(event), filterMatchMode: "contains" });
	}

	public ngOnInit(): void {

	}

	public ngOnChanges(changes: SimpleChanges): void {
		let change: SimpleChange = null;

		this.cols = [];
		this.entries = [];
		this.clearSelectedUsers();

		if (this.visible) {
			this.rebuildColumns();
			this.rebuildEntries();

			if (this.filters) {
				this.filters.forEach((filter: ElementRef<HTMLInputElement>) => {
					filter.nativeElement.value = "";
				});
			}

			this.cols.forEach((col) => {
				this.table.filter("", col.field, col.filterMatchMode)
			});

			setTimeout(() => {
				this.dialog.center();
				setTimeout(() => {
					this.dialog.center();
					setTimeout(() => {
						this.dialog.center();
					}, 400);
				}, 200);
			}, 100);
		}
	}

	public ngOnDestroy(): void {

	}

	public doCustomSort(event): void {
		let comparer = function (a: UserSelectorEntry, b: UserSelectorEntry): number {
			let result = 0;

			switch (event.field) {
				default:
					// Compare string fields
					result = a[event.field].localeCompare(b[event.field]);
					break;
			}

			return result * event.order;
		}

		this.entries.sort(comparer);
	}

	public show(): void {
		this.visible = true;
		this.visibleChange.emit(true);

		this.changeDetector.markForCheck();
	}
	public hide(): void {
		this.visible = false;
		this.visibleChange.emit(false);

		this.changeDetector.markForCheck();
	}

	private clearSelectedUsers(): void {
		this.selectedUsers = (this.maxUsers == 1 ? undefined : []);
	}

	private rebuildEntries(): void {

		this.entries = [];
		this.clearSelectedUsers();

		if (this.usersService.hasUsers) {
			this.usersService.users.ForEach((user: UserDto) => {
				if (!this.except || !this.except.find((userGuid: string) => userGuid === user.Guid)) {
					let entry = new UserSelectorEntry();

					entry.dataKey = user.Guid;
					entry.userTag = user;
					entry.username = user.Username;
					entry.firstName = user.FirstName;
					entry.lastName = user.LastName;
					entry.class = UserClass[user.UserClass];
					entry.type = getAccountTypeLabel(user.AccountType);
					entry.active = (user.IsActive ? 'Yes' : 'No');

					this.entries.push(entry);
				}
			}, this);
		}

		//this.changeDetector.markForCheck();
		this.changeDetector.detectChanges();
	}

	public isOkEnabled(): boolean {
		if (this.maxUsers == 1) {
			return !!this.selectedUsers;
		}
		else {
			if (this.selectedUsers) {
				let len = this.selectedUsers.length;
				return (this.minUsers <= len && len <= this.maxUsers);
			}
			return false;
		}
	}

	public onOkClicked(): void {
		this.onOk.emit(this.getSelectedUsers());
		this.hide();
	}

	public onCancelClicked(): void {
		this.onCancel.emit();
		this.hide();
	}

	private getSelectedUsers(): UserDto[] {
		let result: UserDto[] = [];
		if (this.selectedUsers) {
			if (Array.isArray(this.selectedUsers)) {
				this.selectedUsers.forEach((entry: UserSelectorEntry) => {
					result.push(entry.userTag);
				}, this);
			}
			else {
				let entry = <UserSelectorEntry>this.selectedUsers;
				result.push(entry.userTag);
			}
		}
		return result;
	}

	public get totalUserCount(): number {
		if (this.entries)
			return this.entries.length;
		else
			return 0;
	}

	public get selectedUserCount(): number {
		if (this.selectedUsers) {
			if (Array.isArray(this.selectedUsers)) {
				return this.selectedUsers.length;
			}
			else {
				return 1;
			}
		}
		return 0;
	}
}
